import {
  ChangeDetectionStrategy,
  Component,
  HostListener
} from '@angular/core';
import { ContactInfo } from '../privacy-policy-current/ContactInfo';
import { TableOfContent } from '../privacy-policy-current/TableOfContent';
import { Rights } from '../privacy-policy-current/Rights';
import { Controls } from '../privacy-policy-current/Controls';
import { initFlowbite } from 'flowbite';

@Component({
  selector: 'privacy-policy-v20240313',
  templateUrl: './privacy-policy-v20240313.component.html',
  styleUrls: ['./privacy-policy-v20240313.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrivacyPolicyV20240313Component {
  section3 = false;
  exampleOfTargeting = false;
  activeSection: string = '';
  selectedId: string = '';
  @HostListener('window:scroll', [])
  contactInfo = ContactInfo;
  tableOfContents = TableOfContent;
  rights = Rights;
  controls = Controls;
  isOpen: any;

  ngOnInit() {
    initFlowbite();
    this.isOpen = new Array(this.contactInfo.length).fill(false);
  }

  @HostListener('window:scroll', [])
  onScroll() {
    const scrollPosition = window.scrollY + 100; // Adjust for highlighting

    for (const item of this.tableOfContents) {
      const section = document.getElementById(item.id);
      if (section) {
        const offsetTop = section.offsetTop;
        const offsetHeight = section.offsetHeight;

        if (
          scrollPosition >= offsetTop &&
          scrollPosition < offsetTop + offsetHeight
        ) {
          this.activeSection = item.id;
          break;
        }
      }
    }
  }

  scrollToSection(id: string) {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }

  toggle(property: string) {
    this[property] = !this[property];
  }

  toggleAccordion(index: any) {
    this.isOpen[index] = !this.isOpen[index];
  }
}
